import { dayjs } from "./dayjs";

export const DEFAULT_TIME_ZONE = "UTC";
export type DateTimeZone = string;

export function resolveTimeZone(timeZone?: string) {
  if (!timeZone) return DEFAULT_TIME_ZONE;
  try {
    dayjs.tz(undefined, timeZone);
    return timeZone;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

export function todayIso(timeZone = DEFAULT_TIME_ZONE, now = new Date()) {
  return dayjs(now).tz(resolveTimeZone(timeZone)).format("YYYY-MM-DD");
}

export function isIsoDate(value: string) {
  return dayjs.utc(value, "YYYY-MM-DD", true).isValid();
}

export function addDaysIso(
  value: string,
  amount: number,
  timeZone: DateTimeZone = DEFAULT_TIME_ZONE,
) {
  if (!isIsoDate(value)) return value;
  return dayjs
    .tz(value, "YYYY-MM-DD", resolveTimeZone(timeZone))
    .add(amount, "day")
    .format("YYYY-MM-DD");
}

export function addMonthsIso(value: string, amount: number) {
  if (!/^\d{4}-\d{2}$/.test(value)) return value;
  return dayjs.utc(`${value}-01`, "YYYY-MM-DD", true).add(amount, "month").format("YYYY-MM");
}

export function monthDays(value: string) {
  if (!/^\d{4}-\d{2}$/.test(value)) return 0;
  return dayjs.utc(`${value}-01`, "YYYY-MM-DD", true).daysInMonth();
}

export function monthWeekday(value: string) {
  if (!/^\d{4}-\d{2}$/.test(value)) return 0;
  return dayjs.utc(`${value}-01`, "YYYY-MM-DD", true).day();
}

export function formatIsoMonthDayLabel(value: string, locale: string) {
  if (!isIsoDate(value)) return value;
  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  }).format(dayjs.utc(`${value}`, "YYYY-MM-DD", true).toDate());
}
